import {globMatch} from '../../../js/utils/glob.ts';
import {onInputDebounce, toggleElem, queryElems} from '../../../js/utils/dom.ts';

function initEnableDisable() {
  const toggleTargetContextPanel = (selector: string, enabled: boolean) => {
    if (!selector) return;
    queryElems(document, selector, (el) => el.classList.toggle('disabled', !enabled));
  };
  queryElems<HTMLInputElement>(document, '.enable-security-scanning, .scanner-security-scan-enable', (el) => el.addEventListener('change', () => {
    toggleTargetContextPanel(el.getAttribute('data-target') || '', el.checked);
  }));
}

export function initRepoSettingsSecurity() {
  initEnableDisable();

  const el = document.querySelector<HTMLTextAreaElement>('#security_scan_branch_patterns');
  if (!el) return;

  // show the `Matched` mark for the branches that match the pattern
  const markMatchedBranches = () => {
    const patterns = (el.value || '').split(/[\r\n]+/);
    const validPatterns = patterns.map((item) => item.trim()).filter(Boolean);
    const marks = document.querySelectorAll('.branch-matched-mark');

    for (const el of marks) {
      let matched = false;
      const branchName = el.getAttribute('data-branch-name');
      if (!branchName) continue;
      for (const pattern of validPatterns) {
        if (globMatch(branchName, pattern, '/')) {
          matched = true;
          break;
        }
      }
      toggleElem(el, matched);
    }
  };
  markMatchedBranches();
  el.addEventListener('input', onInputDebounce(markMatchedBranches));
}
